import React from "react";
import { useLiveShopStatus } from "@/lib/liveShopStatus";

/**
 * Prominent Shop Open/Closed status badge.
 * Sizes: "xs" (product cards), "sm" (default), "lg" (shop detail hero)
 */
export default function ShopStatusPill({ status: initial, shopId, size = "sm" }) {
  const status = useLiveShopStatus(shopId, initial);
  if (!status) return null;
  const isOpen = !!status.is_open;
  const label = status.label || (isOpen ? "Open" : "Closed");

  const sizeCls = size === "xs"
    ? "text-[10px] px-1.5 py-0.5 gap-1"
    : size === "lg"
    ? "text-sm px-3 py-1.5 gap-2"
    : "text-[11px] px-2 py-1 gap-1.5";

  const dotSize = size === "lg" ? "w-2 h-2" : "w-1.5 h-1.5";

  const bg = isOpen
    ? "bg-emerald-50 text-emerald-800 border border-emerald-200"
    : "bg-red-50 text-red-800 border border-red-200";

  // Show short OPEN/CLOSED label; full label as title
  const short = isOpen ? "OPEN" : "CLOSED";
  const showFull = size === "lg";

  return (
    <span
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider ${bg} ${sizeCls}`}
      title={label}
      data-testid="shop-status-pill"
      data-open={isOpen ? "true" : "false"}
    >
      <span className={`${dotSize} rounded-full ${isOpen ? "bg-emerald-500 animate-pulse" : "bg-red-500"}`} />
      <span>{short}{showFull && label.trim().toUpperCase() !== short ? ` · ${label}` : ""}</span>
    </span>
  );
}
